import { useParams } from 'react-router-dom';
import { OrderPathParams } from '@app/react/const/type';

export const useOrderPathParams = (): OrderPathParams => {
    const { arrowType, orderType } = useParams<OrderPathParams>();

    return { arrowType, orderType };
};
